import { Typography } from 'Components/atoms';
import RoleDropdown from 'Components/pages/SettingsPage/RoleDropdown';
import { NAME, STATUS, STATUS_OPTIONS } from 'Core-utils/constants/constants';
import { opacityPoliciesClassName, Status } from 'Core-utils/helpers/helpers';
import { TableColumn } from 'react-data-table-component';
import { FaRegEdit } from '@react-icons/all-files/fa/FaRegEdit';
import { AutomoxPoliciesGridProps } from './AutomoxPoliciesGrid';

export type AutomoxPoliciesColumnsType = {
    id: string;
    policyName: string;
    status: string;
};
export const AUTOMOX_POLICIES_COLUMNS = (
    handleEdit: AutomoxPoliciesGridProps['handleEdit'],
    handleUpdateStatus: (row: AutomoxPoliciesColumnsType, status: Status) => void,
): TableColumn<AutomoxPoliciesColumnsType>[] => [
    {
        id: 'policyName',
        name: <Typography variant="body2">{NAME}</Typography>,
        cell: (row: AutomoxPoliciesColumnsType) => (
            <div className={`findings-config__name ${opacityPoliciesClassName(row)}`}>
                <Typography variant="body5">{row.policyName}</Typography>
            </div>
        ),
    },
    {
        id: 'status',
        name: <Typography variant="body2">{STATUS}</Typography>,
        cell: (row: AutomoxPoliciesColumnsType) => {
            const handleDropdownChange = (eventKey: string | null, _e: any) => {
                handleUpdateStatus(row, eventKey as Status);
            };
            return (
                <div className={opacityPoliciesClassName(row)}>
                    <RoleDropdown dropDownItems={STATUS_OPTIONS} value={row.status} onChange={handleDropdownChange} />
                </div>
            );
        },
        sortable: true,
        sortFunction: (rowA: AutomoxPoliciesColumnsType, rowB: AutomoxPoliciesColumnsType) => {
            if (rowA.status === rowB.status) {
                return 0;
            }
            if (rowA.status === Status.ENABLED) {
                return -1;
            }
            if (rowB.status === Status.ENABLED) {
                return 1;
            }
            if (rowA.status === Status.DISABLED) {
                return -1;
            }
            if (rowB.status === Status.DISABLED) {
                return 1;
            }
            return 0;
        },
        width: '20rem',
    },
    {
        id: 'edit',
        cell: (row: AutomoxPoliciesColumnsType) => (
            <div className={opacityPoliciesClassName(row)}>
                <FaRegEdit
                    className="text-text-low-emphasis"
                    cursor={'pointer'}
                    onClick={() => handleEdit(row)}
                    size={16}
                />
            </div>
        ),
        width: '20rem',
    },
];
